import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
 //const URL = process.env.NODE_ENV === 'production' ? undefined : "http://10.1.6.163:3001";
const URL = process.env.NODE_ENV === 'production' ? undefined : `${window.location.hostname}:3001`;

export const socket = io(URL, {transports: ['websocket', 'polling']});
